import { all, put, takeLatest } from 'redux-saga/effects';

import axios from 'axios';
import { PDF_REPORTS } from 'app/api-routes';
import {
  pdfEntityReportsFailure,
  pdfEntityReportsRequest,
  pdfEntityReportsSuccess,
  pdfReportsFailure,
  pdfReportsRequest,
  pdfReportsSuccess,
  setLoading,
} from './actions';
import { PDF_REPORTS_TYPES, SERVER_DATE_TIME_FORMAT } from 'app/types/constants';
import { formatDateTimeUTC } from 'util/formatting';

function* pdfReportsSaga() {
  try {
    yield put(setLoading(true));

    const { payload, warnings } = yield axios.get(PDF_REPORTS);
    yield put(pdfReportsSuccess(payload, { warnings }));
  } catch (err) {
    yield put(pdfReportsFailure(err));
  } finally {
    yield put(setLoading(false));
  }
}

function* pdfEntityReportsSaga({
  payload: { category, clientID, startDate, endDate, siteID, userID, formID, tourID, mobilePatrolID },
}) {
  const params = {};

  if (startDate) {
    params.startDate = formatDateTimeUTC(startDate, SERVER_DATE_TIME_FORMAT);
  }

  if (endDate) {
    params.endDate = formatDateTimeUTC(endDate, SERVER_DATE_TIME_FORMAT);
  }

  if (clientID) {
    params.clientID = clientID;
  }
  if (siteID) {
    params.siteID = siteID;
  }
  if (userID) {
    params.userID = userID;
  }

  if (formID) {
    params.formID = formID;
  }

  if (tourID) {
    params.tourID = tourID;
  }

  if (mobilePatrolID) {
    params.mobilePatrolID = mobilePatrolID;
  }

  try {
    let payload = [];

    switch (category) {
      case PDF_REPORTS_TYPES.FORM_REPORT: {
        const { payload: formReports } = yield axios.get(`${PDF_REPORTS}/form-pdf-reports`, { params });
        payload = formReports;
        break;
      }

      case PDF_REPORTS_TYPES.INCIDENT_REPORT: {
        const { payload: incidentReports } = yield axios.get(`${PDF_REPORTS}/incident-pdf-reports`, {
          params,
        });
        payload = incidentReports;
        break;
      }

      case PDF_REPORTS_TYPES.SHIFT_REPORT: {
        const { payload: shiftReports } = yield axios.get(`${PDF_REPORTS}/shift-pdf-reports`, {
          params,
        });
        payload = shiftReports;
        break;
      }

      case PDF_REPORTS_TYPES.MOBILE_PATROL_SHIFT_REPORT_EXTENDED: {
        const { payload: mobilePatrolShiftReportsExtended } = yield axios.get(
          `${PDF_REPORTS}/mobile-unit-shift-reports-extended`,
          {
            params,
          }
        );
        payload = mobilePatrolShiftReportsExtended;
        break;
      }

      case PDF_REPORTS_TYPES.TOUR_REPORT: {
        const { payload: tourReports } = yield axios.get(`${PDF_REPORTS}/tour-pdf-reports`, {
          params,
        });
        payload = tourReports;
        break;
      }

      case PDF_REPORTS_TYPES.DAILY_SITE_VISITS_REPORT: {
        const { payload: dailySiteVisitsPDFReports } = yield axios.get(
          `${PDF_REPORTS}/daily-site-visits-pdf-reports`,
          {
            params,
          }
        );
        payload = dailySiteVisitsPDFReports;
        break;
      }

      case PDF_REPORTS_TYPES.DAILY_SITE_ACTIVITY_REPORT: {
        const { payload: dailySiteActivityPDFReports } = yield axios.get(
          `${PDF_REPORTS}/daily-site-activity-pdf-reports`,
          {
            params,
          }
        );
        payload = dailySiteActivityPDFReports;
        break;
      }

      case PDF_REPORTS_TYPES.SITE_VISIT_REPORT: {
        const { payload: siteVisitsPDFReports } = yield axios.get(`${PDF_REPORTS}/site-visits-pdf-reports`, {
          params,
        });
        payload = siteVisitsPDFReports;
        break;
      }

      case PDF_REPORTS_TYPES.MOBILE_UNIT_SITE_VISIT_SUMMARY_EXTENDED_REPORT: {
        const { payload: mobileUnitSiteVisitSummaryExtendedPDFReports } = yield axios.get(
          `${PDF_REPORTS}/mobile-unit-site-visit-summary-extended-pdf-reports`,
          {
            params,
          }
        );
        payload = mobileUnitSiteVisitSummaryExtendedPDFReports;
        break;
      }

      case PDF_REPORTS_TYPES.MOBILE_PATROL_SHIFT_REPORT: {
        const { payload: mobilePatrolShiftReports } = yield axios.get(
          `${PDF_REPORTS}/mobile-unit-shift-reports`,
          {
            params,
          }
        );
        payload = mobilePatrolShiftReports;
        break;
      }
    }
    yield put(pdfEntityReportsSuccess({ category, data: payload }));
  } catch (err) {
    yield put(pdfEntityReportsFailure(err));
  }
}

export default function* () {
  yield all([
    yield takeLatest(pdfReportsRequest, pdfReportsSaga),
    yield takeLatest(pdfEntityReportsRequest, pdfEntityReportsSaga),
  ]);
}
